import { Small } from '@comeon/ui';
import styled from 'styled-components';

const SportsbookLivePill = styled(Small)`
	color: var(--lobby-header-on-surface-secondary);
	background-color: var(--lobby-header-surface-secondary);
	padding: 1px 4px;
	border-radius: var(--base-radius-small);
	font: var(--small-bold);
`;

export default SportsbookLivePill;
